<section class="dealers-page">
  <section class="banner content-section">
    <div>
      <div class="row">
        <div>
          <div class="banner-content text-center">
            <h1 class="content-h1">Become A FreeUp Mobile Dealer Today</h1>
            <h3 class="subhead">
              FreeUp mobile is changing the wireless world. Be part of the most exciting thing to happen in wireless in
              years.
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-fill subtle" style="background-image: url(/assets/img/banners/FreeUP-Sunset_Road.jpg)"></div>
  </section>
  <section class="content-section feature-section" id="features">
    <div>
      <div class="feature-flex top">
        <div class="feature">
          <img height="100" width="100" src="/assets/icon/THE BEST 4G LTE NETWORK.svg" alt="USA map">
          <h4>The Bes 4G LTE Network</h4>
          <div class="description">FreeUP Mobile customers have access to the largest and fastest 4G LTE Network
            covering 99% of the population.
          </div>
        </div>
        <div class="feature">
          <img height="100" width="100" src="/assets/icon/BRING YOUR OWN DEVICE.svg" alt="phone device">
          <h4>Bring Your Own Device</h4>
          <div class="description">FreeUP Mobile is compatible with almost all GSM devices.</div>
        </div>
        <div class="feature">
          <img height="100" width="100" src="/assets/icon/Easy to use.svg" alt="SIM card">
          <h4>Easy to Use</h4>
          <div class="description">Selling, activating and supporting FreeUP is easy. Just sign up with one of our
            fully integrated TSPs and get started.
          </div>
        </div>
      </div>
      <div class="feature-flex">
        <div class="feature">
          <img height="100" width="100" src="/assets/icon/BEST GLOBAL PLANS.svg" alt="Reward badge">
          <h4>Best Global Plans</h4>
          <div class="description">We offer the best Int’l Calling plan to 150+ destinations on the Best 4G LTE
            network.
          </div>
        </div>
        <div class="feature last">
          <img height="100" width="100" src="/assets/icon/STRONG RETAILER COMMISSIONS.svg" alt="Reward cup">
          <h4>Strong Retailer Commissions</h4>
          <div class="description">
            FreeUP Mobile dealers are able to receive activation incentives as well as participate in residuals and
            airtime revenue.
            <br>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="content-section brand-names-section">
    <div>
      <div>
        <h2 class="centered">Full Activation and RTR Integration:</h2>
        <div class="text-center">
          <div class="images-row">
            <div class="first-img">
              <img src="/assets/img/emida-img.png" srcset="/assets/img/emida-img@2x.png 2x,
                   /assets/img/emida-img@3x.png 3x" class="emedia" alt="eMedia logo">
            </div>
            <div class="second-img">
              <img src="/assets/img/reupmob.jpeg" class="reupmob">
            </div>
            <div class="third-img"> <img src="/assets/img/prepay.png" class="prepay" alt="prepay logo"> </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="content-section brand-names-section last">
    <div>
      <h2 class="centered">Airtime PINs Available At:</h2>
      <div>
        <div class="text-center">
          <div class="images-row">
            <div class="first-img"><img src="/assets/img/incomm-img.png" srcset="/assets/img/incomm-img@2x.png 2x,
                     /assets/img/incomm-img@3x.png 3x" class="incom" alt="Incomm logo"></div>
            <div class="second-img"> <img src="/assets/img/vida-pay-img.png" srcset="/assets/img/vida-pay-img@2x.png 2x,
                     /assets/img/vida-pay-img@3x.png 3x" class="vida" alt="vida logo"></div>
            <div class="third-img"> <img src="/assets/img/epay-img.png" srcset="/assets/img/epay-img@2x.png 2x,
                     /assets/img/epay-img@3x.png 3x" class="epay" alt="epay logo"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="content-section alt-bg">
    <div class="form-holder">
      <div class="text-center">
        <h2 class="ready">Ready to get started with FreeUP Mobile?</h2>
        <h5 class="subhead">
          Please fill out this form and we will contact you with information on how you can start selling America's most
          exciting wireless solutions.
        </h5>
        <div class="form-margins">
          <form class="pad-form" [formGroup]="dealerForm">
            <div class="row text-left">
              <div class="fieldset-flex">
                <fieldset>
                  <label class="outlined-label-input">
                    <input type="text" name="fname" id="fname" formControlName="fname" required placeholder=" " />
                    <span>First Name</span>
                  </label>

                  <label class="validation-message"
                    *ngIf="dealerForm.controls.fname.hasError('required') && dealerForm.controls.fname.touched">
                    First name is required
                  </label>
                  <label class="validation-message" *ngIf="dealerForm.controls.fname.hasError('pattern')">
                    First name is invalid
                  </label>
                </fieldset>

                <fieldset>
                  <label class="outlined-label-input">
                    <input type="text" name="lname" id="lname" formControlName="lname" required placeholder=" " />
                    <span>Last Name</span>
                  </label>

                  <label class="validation-message"
                    *ngIf="dealerForm.controls.lname.hasError('required') && dealerForm.controls.lname.touched">
                    Last name is required
                  </label>
                  <label class="validation-message" *ngIf="dealerForm.controls.lname.hasError('pattern')">
                    Last name is invalid
                  </label>
                </fieldset>
              </div>

              <div class="fieldset-flex">
                <fieldset>
                  <label class="outlined-label-input">
                    <input type="text" name="storeName" id="storeName" formControlName="storeName" required
                      placeholder=" " />
                    <span>Store Name</span>
                  </label>

                  <label class="validation-message"
                    *ngIf="dealerForm.controls.storeName.hasError('required') && dealerForm.controls.storeName.touched">
                    Store name is required
                  </label>
                </fieldset>

                <fieldset>
                  <label class="outlined-label-input">
                    <input type="text" name="email" id="email" formControlName="email" required placeholder=" " />
                    <span>Email</span>
                  </label>

                  <label class="validation-message"
                    *ngIf="dealerForm.controls.email.touched && dealerForm.controls.email.hasError('required')">Email
                    is required
                  </label>
                  <label class="validation-message" *ngIf="dealerForm.controls.email.hasError('pattern')"> Email address
                    is invalid
                  </label>
                </fieldset>

                <fieldset>
                  <label class="outlined-label-input">
                    <input type="text" name="phone" id="phone" formControlName="phone" placeholder=" "
                      mask="(000) 000-0000000000" restrictNumbers required />
                    <span>Phone</span>
                  </label>

                  <label class="validation-message"
                    *ngIf="dealerForm.controls.phone.hasError('required') && dealerForm.controls.phone.touched">
                    Phone is required
                  </label>
                  <label class="validation-message"
                    *ngIf="dealerForm.controls.phone.hasError('pattern') && dealerForm.controls.phone.touched">
                    Invalid phone number
                  </label>
                </fieldset>
              </div>

              <fieldset class="twelve form-actions text-alt-align">
                <button type="submit" value="Submit" class="button primary large"
                  [uiBlockButton]="processingRequest" (click)="sendMessage()">
                  Submit
                </button>
              </fieldset>
            </div>
          </form>
        </div>
      </div>
      <div class="cant-wait">
        <h3>
          Can't wait to get started?
        </h3>
        <div class="subhead">
          Call <a href="tel:800-541-3108"> 800-541-3108</a> and talk to us today.
        </div>
      </div>
    </div>
  </section>
</section>
